export const dataHooks = {
    tableListItemValue: 'tableListItem-value',
    tableListItemCheckbox: 'tableListItem-checkbox',
    tableListItemCheckboxContainer: 'tableListItem-checkboxContainer',
    tableListItemOptionsContainer: 'tableListItem-optionsContainer',
    tableListItemDragHandle: 'tableListItem-dragHandle',
    tableListItemExpandHandleContainer: 'tableListItem-expandHandleContainer',
    tableListItemExpandHandle: 'tableListItem-expandHandle',
};
export const ALIGN = {
    left: 'left',
    center: 'center',
    right: 'right',
};
export const PADDING = {
    xxTiny: 'xxTiny',
    xTiny: 'xTiny',
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=constants.js.map